import { useSyncExternalStore } from 'react';
import { getPresentation, getPresentationMode, subscribePresentation } from '../presentation/runtime';

export default function GoodvaleWordmark({ className = 'w-32', alt = 'Goodvale' }) {
  useSyncExternalStore(subscribePresentation, getPresentationMode);
  return <img src={getPresentation().wordmark} alt={alt} width={2172} height={724} className={`block h-auto shrink-0 object-contain ${className}`} />;
}
